export default "__VITE_ASSET__D8KvI4Ky__"